import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

export default function TagMissingDialog({ open, onClose, onAddTag, onConfirmPhysical }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>La etiqueta no está presente</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Este radicado aún no tiene la etiqueta (QR) estampada en el documento.
          ¿Deseas agregarla ahora?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onConfirmPhysical}>
          No, la etiqueta fue añadida físicamente
        </Button>
        <Button onClick={onAddTag} variant="contained" autoFocus>
          Sí, agregar etiqueta
        </Button>
      </DialogActions>
    </Dialog>
  );
}
